module.exports = __webpack_public_path__ + "fonts/StagSans-Bold-Italic.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Bold-Italic.otf
// module id = 1095
// module chunks = 0